/*eslint-disable*/
import { createContext, useState, useEffect } from "react";
import { courseHelper } from "../helpers";

export const IboContext = createContext();

const IboProvider = ({ children }) => {
  const userInfoQursiva = localStorage.getItem("userInfoQursiva")
    ? JSON.parse(localStorage.getItem("userInfoQursiva"))
    : undefined;

  const iboInLocal = localStorage.getItem("iboInfo")
    ? JSON.parse(localStorage.getItem("iboInfo"))
    : undefined;

  const [iboInfo, setIboInfo] = useState(iboInLocal);
  const [purchasedCourses, setPurchasedCourses] = useState([]);

  const setIboInfoLocal = (data) => {
    setIboInfo(data);
    localStorage.setItem("iboInfo", JSON.stringify(data));
  };

  /* Limpia el código IBO. Usado por el botón "Salir" del chip
     "Invitado · Referido por X" del navbar cuando el visitante
     quiere volver a estado anónimo. Al actualizar el context, todos
     los consumidores (AppTopNav, home, courses…) re-renderizan y
     dejan de mostrar el estado de invitado. Antes se llamaba
     `logOut()` del AuthContext, pero éste no gatillaba re-render
     porque `setUserInfoQursiva(false)` en un usuario que YA era
     `false` no dispara actualización. */
  const clearIboInfo = () => {
    setIboInfo(undefined);
    localStorage.removeItem("iboInfo");
  };

  useEffect(() => {
    validatePurchase();
  }, []);
  
  async function validatePurchase() {
    if(userInfoQursiva) {
      setPurchasedCourses(
        await courseHelper.validateAccess(userInfoQursiva.userRelationId)
      );
    } else {
      setPurchasedCourses([])
    }
  }

  return (
    <IboContext.Provider
      value={{
        iboInfo,
        setIboInfo,
        setIboInfoLocal,
        clearIboInfo,
        purchasedCourses,
        setPurchasedCourses,
        validatePurchase
      }}
    >
      {children}
    </IboContext.Provider>
  );
};

export default IboProvider;
